// Polyfills
import 'core-js/es/array';
import 'core-js/es/promise';
import 'core-js/es/symbol';
import 'core-js/web/dom-collections';
import 'core-js/es/set';
import 'whatwg-fetch';
import 'picturefill';

// Assets
import 'icons';
import 'img';
import 'fonts';
import 'videos';
// LazySizes
import 'lazysizes';
// Lodash
import _throttle from 'lodash/throttle';

// NOTE Hack to have this dummy JSON available for file-loader to copy into the dist folder.
// The dummy JSON is later replaced by an API call.
// eslint-disable-next-line import/no-unresolved
require('json/ticker-data.json');
require('json/login.json');
require('json/videos.json');
// require('json/ticker-data2.json');

(() => {
  /**
   * DOM may not be ready
   */

  const modulePromiseResolver = ({ default: Module }) => new Promise((resolve) => resolve(Module));

  window.addEventListener('lazyloaded', () => {
    // eslint-disable-next-line no-console
  });

  /**
   * Observe window scrolling
   */
  window.addEventListener('scroll', _throttle(() => {
    // Toggle global 'is-scrolling' class on body
    document.body.classList[document.body.getBoundingClientRect().top < 0 ? 'add' : 'remove']('is-scrolling');
  }, 200));

  /**
   * Wait until DOM is ready
   */
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize SearchBox
    const searchboxItems = document.querySelectorAll('.js-searchbox');
    if (searchboxItems.length) {
      import(/* webpackChunkName: 'searchbox' */ 'components/searchbox/searchbox').then(modulePromiseResolver).then((SearchBox) => {
        searchboxItems.forEach((element) => {
          new SearchBox(element);
        });
      });
    }

    // Initialize Bineos
    const tracker = { ...document.body.dataset };
    if (tracker.bineosContainer && tracker.bineosDomain && tracker.bineosTouchpoint) {
      const dataLayer = window.dataLayer || [];
      const bineosTag = document.createElement('script');
      document.head.appendChild(bineosTag);
      bineosTag.onload = () => {
        const bineos = window.Bineos ? window.Bineos : null;
        import(/* webpackChunkName: 'bineos' */ 'components/tracker/bineos').then(modulePromiseResolver).then((HazBineos) => {
          const bineosInstance = (new HazBineos({
            container: tracker.bineosContainer,
            domain: tracker.bineosDomain,
            touchpoint: tracker.bineosTouchpoint,
            taxonomy: tracker.bineosTaxonomy || '',
            ivw: tracker.bineosIvw || '',
            document,
            dataLayer,
            bineos,
          })).track();

          // Initialize Xpresso
          const sso = document.querySelector('#xpresso_funnel');
          if (document.querySelectorAll('#xpresso_funnel').length) {
            import(/* webpackChunkName: 'xpresso-client' */ 'external/Xpresso/xpresso-client').then(modulePromiseResolver).then((XpressoClient) => {
              new XpressoClient({
                id: sso.dataset.xpressoId,
                baseUrl: sso.dataset.xpressoBaseurl,
                apiKey: sso.dataset.xpressoApikey,
                pageContainerId: 'xpresso_funnel',
                vendor: bineosInstance,
                exitUrl: `//${window.location.host}/connect/xpresso`,
              });
            });
          }
        });
      };
      bineosTag.src = 'https://cdn.dl.hildesheimer-allgemeine.de/bineosha/content/Bineos_2_0/bineos.min.js';
    }

    // Initialize LastUpdated
    const lastUpdatedItems = document.querySelectorAll('.js-last-updated');
    if (lastUpdatedItems.length) {
      import(/* webpackChunkName: 'last-updated' */ 'components/last-updated/last-updated').then(modulePromiseResolver).then((LastUpdated) => {
        lastUpdatedItems.forEach((element) => {
          new LastUpdated(element);
        });
      });
    }

    // Initialize Poll
    const pollItems = document.querySelectorAll('.js-poll');
    if (pollItems.length) {
      import(/* webpackChunkName: 'poll' */ 'components/poll/poll').then(modulePromiseResolver).then((Poll) => {
        pollItems.forEach((element) => {
          new Poll(element);
        });
      });
    }

    // Initialize user name
    const customizedUI = document.querySelectorAll('.js-customizedUI');
    if (customizedUI.length) {
      import(/* webpackChunkName: 'customlogin' */ 'components/login/login').then(modulePromiseResolver).then((CustomizedLogin) => {
        // Render once, iterate inside for mobile and desktop
        new CustomizedLogin(customizedUI);
      });
    }

    // Initialize Gallery
    if (document.querySelectorAll('.glightbox').length) {
      import(/* webpackChunkName: 'glightbox' */ 'glightbox').then(modulePromiseResolver).then((GLightbox) => {
        GLightbox({ moreText: 'mehr anzeigen' });
      });
    }

    // social media blocker script
    const gdprBlocker = document.querySelectorAll('.js-gdpr-script');
    if (gdprBlocker.length) {
      import(/* webpackChunkName: 'iframe' */ 'components/iframe/iframe').then(modulePromiseResolver).then((GdprBlocker) => {
        new GdprBlocker(gdprBlocker);
      });
    }

    // Slider
    const slider = document.querySelectorAll('.mySwiper');
    if (slider.length) {
      import(/* webpackChunkName: 'slider' */ 'components/slider/slider').then(modulePromiseResolver).then((Slider) => {
        slider.forEach((element) => {
          new Slider(element);
        });
      });
    }

    // Videolider
    const videoslider = document.querySelectorAll('.vs-container');
    if (videoslider.length) {
      import(/* webpackChunkName: 'videoslider' */ 'components/videoslider/videoslider').then(modulePromiseResolver).then((Videoslider) => {
        videoslider.forEach((element) => {
          const vslider = new Videoslider(element);

          if (element.dataset.href) {
            vslider.initialize(fetch(element.dataset.href));
          }
        });
      });
    }

    // Initialize Datepicker
    const datepickerItems = document.querySelectorAll('.js-datepicker');
    if (datepickerItems.length) {
      import(/* webpackChunkName: 'datepicker' */ 'forms/datepicker/datepicker').then(modulePromiseResolver).then((Datepicker) => {
        datepickerItems.forEach((element) => {
          new Datepicker(element);
        });
      });
    }

    // Initialize Ad seeding
    if (document.querySelectorAll('.js-ad-seeding').length) {
      import(/* webpackChunkName: 'ad-seeding' */ 'components/ad/ad-seeding').then(modulePromiseResolver).then((AdSeeding) => {
        new AdSeeding();
      });
    }

    // Initialize Ad taboola
    if (document.querySelectorAll('.js-ad-taboola').length) {
      import(/* webpackChunkName: 'ad-taboola' */ 'components/ad/ad-taboola').then(modulePromiseResolver).then((AdTaboola) => {
        new AdTaboola();
      });
    }

    // Initialize Ad taboola paid
    if (document.querySelectorAll('.js-ad-paid-taboola').length) {
      import(/* webpackChunkName: 'ad-taboola' */ 'components/ad/ad-paid-taboola').then(modulePromiseResolver).then((AdPaidTaboola) => {
        new AdPaidTaboola();
      });
    }

    // Initialize Ad stroeer
    if (document.querySelectorAll('.js-ad-stroeer').length) {
      import(/* webpackChunkName: 'ad-stroeer' */ 'components/ad/ad-stroeer').then(modulePromiseResolver).then((AdStroeer) => {
        const stroeer = new AdStroeer(window.haz.ads);
        window.addEventListener('resize', stroeer.update(window.haz.globalTimeout));
      });
    }

    // Initialize Ticker
    const ticker = document.querySelectorAll('.js-ticker-data');
    if (ticker.length) {
      import(/* webpackChunkName: 'ticker' */ 'components/ticker/ticker').then(modulePromiseResolver).then((Ticker) => {
        ticker.forEach((element) => {
          new Ticker(element);
        });
      });
    }

    // const vueAppsElements = document.querySelectorAll('[data-vue-app]');
    // if (vueAppsElements.length > 0) {
    //   vueAppsElements.forEach((element) => {
    //     const appName = element.dataset.vueApp;
    //     eslint-disable-next-line max-len
    //         import(/* webpackChunkName: '[request]' */ `components/${appName}/${appName}-app`).then(modulePromiseResolver).then((loader) => {
    //           loader(element);
    //         });
    //   });
    // }
  });

  /**
   * Wait until window is loaded

   window.addEventListener('load', () => {

    // Do something that requires the window to be fully loaded

  });
   */
})();

if (module.hot) {
  module.hot.accept();
}
